import * as React from 'react';
import {Card, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {lineElementClasses, LinePlot} from '@mui/x-charts/LineChart';
import IconButton from "@mui/material/IconButton";
import {MoreVertOutlined, PortraitOutlined} from '@mui/icons-material';
import {ChartContainer, ChartsItemTooltipContent, ChartsTooltip} from "@mui/x-charts";
import {XYVO} from "@/service/analyze";
import {sumBy} from "lodash";
import {ChartsLoadingOverlay} from "@mui/x-charts/ChartsOverlay";

export interface PatentCardProps {
    patents?: XYVO[]
    loading: boolean
}

export default function PatentCard({loading, patents = []}: PatentCardProps) {
    return (
        <Card variant="outlined" sx={{height: '100%', flexGrow: 1, backgroundColor: '#e7e2f3'}}>
            <CardContent sx={{height: '100%'}}>
                <Stack justifyContent={'space-between'} height={'inherit'}>
                    <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                        <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                            <IconButton sx={{bgcolor: '#8965e5', padding: '4px 12px', borderRadius: '99999px'}}>
                                <PortraitOutlined sx={{color: '#fff'}}/>
                            </IconButton>
                            <Typography fontWeight={500} component="h1" color={'#7b8893'} variant='body1'>
                                专利
                            </Typography>
                        </Stack>
                        <MoreVertOutlined color={'action'}/>
                    </Stack>
                    <Grid container rowSpacing={6} alignItems={'end'}>
                        <Grid size={5}>
                            <Chip label={<Typography fontSize={'12px'} color={'textSecondary'}>全部</Typography>}/>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={20} fontWeight={550}>{sumBy(patents, item => item.y) || 0}个</Typography>
                        </Grid>
                        <Grid size={7}>
                            <ChartContainer
                                localeText={{loading: loading ? "加载中" : ""}}
                                height={100}
                                yAxis={[{position: 'none'}]}
                                sx={{
                                    [`.${lineElementClasses.root}`]: {
                                        strokeWidth: 4,
                                    },
                                }}
                                margin={{left: 0, right: 0, top: 0, bottom: 0}}
                                series={[{data: patents?.map(item => item.y) || [], type: 'line', color: '#8965e5'}]}
                                xAxis={[{
                                    scaleType: 'band', data: patents?.map(item => item.x) || []
                                },] as any}
                            >
                                <ChartsLoadingOverlay/>
                                <LinePlot/>
                                <ChartsTooltip/>
                            </ChartContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    );
}
